import "../scss/fundraiser-form.scss";

import * as tingle from "tingle.js";
import { fundraiserExamples } from "./modules/fundraisers/fundraiserExamples";
import { FundraiserForm } from "./modules/fundraisers/FundraiserForm";
import { globalDef } from "./modules/siteDefinitions";
import "./account-trigger";

// Check if the current page is edit and set the variable accordingly
const editPage = document.querySelector(".fundraiser-form--edit") ? true : false;

new FundraiserForm(editPage);

// Listen for onload function call from the recaptcha script
(window as any).loadFundraiserRecaptcha = () => {
    // Create and dispatch an event to render the Recaptcha
    const event = new CustomEvent("loadFundraiserRecaptcha");

    window.dispatchEvent(event);
};

const ajaxPopups = document.querySelectorAll(".fundraiser-example__popup");
if (ajaxPopups.length > 0) {
    const viewSampleModal = new tingle.modal({
        cssClass: ["tingle-full", "campaign-preview", "overflow"],
    });

    for (const ajaxPopup of ajaxPopups) {
        ajaxPopup.addEventListener("click", (e) => {
            fundraiserExamples(e, ajaxPopup as HTMLElement, viewSampleModal);
        });
    }
}

// Locations

const defaultCmp = function (a: string, b: string) {
    if (a === b) {
        return 0;
    }
    return a < b ? -1 : 1;
};

const getCmpFunc = function (primer: any, reverse: any) {
    let cmp = defaultCmp;
    if (primer) {
        cmp = function (a, b) {
            return defaultCmp(primer(a), primer(b));
        };
    }
    if (reverse) {
        return function (a: string, b: string) {
            return -1 * cmp(a, b);
        };
    }
    return cmp;
};

const sortBy = function (...args: any[]) {
    const fields: any = [];
    const nFields = arguments.length;
    let field;
    let name;
    // reverse,
    let cmp;

    // preprocess sorting options
    for (let i = 0; i < nFields; i++) {
        field = args[i];
        if (typeof field === "string") {
            name = field;
            cmp = defaultCmp;
        } else {
            name = field.name;
            cmp = getCmpFunc(field.primer, field.reverse);
        }
        // eslint-disable-next-line
        fields.push({ name: name, cmp: cmp });
    }

    return function (A: string, B: string) {
        let name2: any;
        let cmp2: any;
        let result;
        for (let i = 0, l = nFields; i < l; i++) {
            result = 0;
            field = fields[i];
            name2 = field.name;
            cmp2 = field.cmp;

            result = cmp2(A[name2], B[name2]);
            if (result !== 0) {
                break;
            }
        }
        return result; // eslint-disable-line
    };
};


async function getLocationsByPartnerId(entityID: string) {
    return jQuery.ajax({
        url: `${globalDef.mainDomain + globalDef.ajaxFunctionsUrl}function=getLocationsFromPartnerId&id=${entityID}`,
        complete(response) {
            
            const respText = JSON.parse(response.responseText);
            const option = jQuery("<option></option>").attr("value", "-1").text("Choose a Location");
            jQuery("#Location_ID").empty().append(option);

            respText.sort(sortBy("state", { name: "city" }));

            if (respText.length > 0) {
                jQuery("#partner_select_location").show();
            } else {
                jQuery("#partner_select_location").hide();
            }

            jQuery.each(respText, function (resp) {
                const option = jQuery("<option></option>")
                    .attr("value", respText[resp].locationNumber)
                    .text(`${respText[resp].locationNumber as string} - ${respText[resp].state as string}${respText[resp].city !== "" ? ", " : ""}${respText[resp].city as string}`);

                jQuery("#Location_ID").append(option);
            });
        },
        error() {
            const option = jQuery("<option></option>").attr("value", "-1").attr("selected", "true").text("Choose a Location");
            jQuery("#Location_ID").empty().append(option);
        },
    });
}

async function getLocationsForPartner(selectOption = false) {
    const option = jQuery("<option></option>").attr("value", "-1").text("Loading...");
    jQuery("#Location_ID").empty().append(option);

    const entityID = jQuery("#Partner_ID").val() as string;
    const locationID = jQuery("#Location_ID").attr("data-location-id") || "-1";

    if (entityID === "-1") {
        jQuery("#partner_select_location").hide();
    } else {
        jQuery("#partner_select_location").show();
        await getLocationsByPartnerId(entityID);

        if (selectOption) {
            jQuery("#Location_ID").val(locationID);
        }
    }
}

jQuery(async () => {
    await getLocationsForPartner(true);
});

document.getElementById("Partner_ID")?.addEventListener("change", () => {
    getLocationsForPartner();
});
